/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function r(r){return"url"in r&&"urlHash"in r?{...r,url:""}:r}export{r as discardUrlIfHasUrlHash};
